import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { PillButtonDTO } from '@app/infrastructure/models/pill-button-dto';
import { HostListener } from '@angular/core';
import { ITeacherClassDetailDTO } from '@app/infrastructure/models/teacher-classroom';

@Component({
  selector: 'app-pill-button-list-presentation',
  templateUrl: './pill-button-list.component.html',
  styleUrls: ['./pill-button-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillButtonListComponent implements OnInit {
  @Input() pillButtonDTOList: PillButtonDTO[] = [];
  @Input() gradingLink: string;
  @Input() hasEdit: boolean;
  @Input() public classroom: ITeacherClassDetailDTO;
  @Output() selectionEvent = new EventEmitter<PillButtonDTO>();
  @Output() editEvent = new EventEmitter<void>();

  screenHeight: number;
  screenWidth: number;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.screenWidth = window.outerWidth;
    this.screenHeight = window.outerHeight;
    this.cdr.detectChanges();
  }

  onSelectedChanged(event: PillButtonDTO) {
    // Disallow multi-select...
    // this.resetSelected();

    const changeSelected = this.toggleSelected(
      this.pillButtonDTOList.find((dto) => dto.id === event.id),
    );
    // Bubble up . ◦°
    if (changeSelected) {
      this.selectionEvent.emit(event);
    }
  }

  onEditClicked(event) {
    this.editEvent.emit();
  }

  resetSelected(id: string) {
    this.pillButtonDTOList = this.pillButtonDTOList.map((dto) => {
      if (dto.id !== id)
        return {
          ...dto,
          selected: false,
        };
      else {
        return {
          ...dto,
        };
      }
    });
  }

  toggleSelected(dto: PillButtonDTO): boolean {
    if (dto.selected !== true) {
      dto.selected = true;
      this.resetSelected(dto.id);
      return true;
    } else {
      this.resetSelected(dto.id);
      return false;
    }
  }

  deselectButton(dto: PillButtonDTO) {
    dto.selected = false;
  }

  selectButton(dto: PillButtonDTO) {
    dto.selected = true;
  }

  getColumns(): string {
    let cols = 'four-items';
    const val = this.screenWidth;

    if (val < 500) {
      cols = 'one-item';
    } else if (val < 775) {
      cols = 'two-items';
    } else if (val < 1025) {
      cols = 'three-items';
    } else {
      cols = 'four-items';
    }

    return cols;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.changeScreenSize();
  }

  changeScreenSize() {
    this.screenHeight = window.outerHeight;
    this.screenWidth = window.outerWidth;
    this.cdr.detectChanges();
  }
}
